import constants, { ACCESS_TOKEN, HTTP_METHODS, default_size} from "../../../settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getuserlist(id, page = 0, size = default_size) {
    return axiosClient({
        url: `${constants.api.usermanagement.get_userlist}${id}?page=${page}&size=${size}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function createuser(data) {
    return axiosClient({
        url: constants.api.usermanagement.create_user,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function deleteuser(id) {
    return axiosClient({
        url: constants.api.usermanagement.delete_user + id,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ''
    })
}

//To export run function
const UserManagementService = {
    getuserlist, createuser, deleteuser
}
export default UserManagementService;
